var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStats = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.912 2.943v-.001a.473.473 0 0 0-.01-.656.472.472 0 0 0-.656-.011h-.001l-2.62 2.62-1.354-1.353a.472.472 0 0 0-.667 0L2.776 5.37h-.001a.472.472 0 0 0 .011.656.472.472 0 0 0 .656.012v-.001l1.495-1.495 1.355 1.354a.472.472 0 0 0 .666 0l2.954-2.953Zm-.046-.622a.423.423 0 0 1 .01.587l-.01-.587ZM1.894 8.044v-6.56a.472.472 0 0 0-.944 0v7.032a.472.472 0 0 0 .472.472h8.156a.472.472 0 0 0 0-.944H1.894Z",
    fill: "#62605D",
    stroke: "#62605D",
    strokeWidth: 0.1
  })));
};
export default SvgStats;